import Vue from 'vue'
import App from './App.vue'

import router from './router'
// import store from './store'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import '../public/static/css/base.css'
import '../public/static/icon/iconfont.css'
import '../public/static/css/elementEdit.css'

Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')